import {
	defaultHazardsFormState,
	defaultHazardousSubstancesFormState,
	defaultPeopleFormState,
	defaultRecipientsFormState,
	defaultSiteFormState,
	defaultInductionMeetingsFormState,
	isLocked,
} from "features/forms";

import {
	defaultSaveState,
	saveRequested,
	saveFailed,
	saveSuccess,
} from "utils";

import * as fromActions from "../actions/types";

export const defaultState = {
	...defaultSaveState,
	...defaultHazardsFormState,
	...defaultHazardousSubstancesFormState,
	...defaultPeopleFormState,
	...defaultRecipientsFormState,
	...defaultSiteFormState,
	...defaultInductionMeetingsFormState,
};

const reducer = (state = defaultState, action) => {
	switch (action.type) {
		case fromActions.ADD_INDUCTION_MINUTES_FORM_RESET:
			return defaultState;
		case fromActions.ADD_INDUCTION_MINUTES_FORM_VALUE_CHANGE:
			return isLocked({
				...state,
				...action.payload,
			});
		case fromActions.ADD_INDUCTION_MINUTES_FORM_SUBMIT:
			return isLocked(saveRequested(state));
		case fromActions.ADD_INDUCTION_MINUTES_FORM_SUBMIT_FAILED:
			return isLocked(saveFailed(state, action.payload));
		case fromActions.ADD_INDUCTION_MINUTES_FORM_SUBMIT_SUCCESS:
			return isLocked(saveSuccess(state));
		default:
			return isLocked(state);
	}
};

export default reducer;
